var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPollPollEOops = function SvgPollPollEOops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#poll-poll-e-oops_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M59.85 0c8.033 0 14.816 5.353 16.978 12.687A24 24 0 0 1 84.6 11.4c13.254 0 24 10.746 24 24 0 2.67-.437 5.236-1.242 7.634C114.669 45.211 120 51.982 120 60c0 8.017-5.331 14.788-12.642 16.965A24 24 0 0 1 108.6 84.6c0 13.254-10.746 24-24 24-2.67 0-5.237-.437-7.635-1.242C74.788 114.669 68.017 120 60 120c-8.018 0-14.79-5.331-16.966-12.642A24 24 0 0 1 35.4 108.6c-13.254 0-24-10.746-24-24 0-2.67.436-5.237 1.24-7.635C5.33 74.788 0 68.017 0 60s5.33-14.79 12.64-16.966A24 24 0 0 1 11.4 35.4c0-13.254 10.746-24 24-24 2.619 0 5.139.42 7.498 1.196C45.088 5.309 51.848 0 59.85 0m-.93 15.556c-.433 23.81-19.586 43.045-43.364 43.607v1.673c23.778.562 42.931 19.798 43.364 43.608h1.667c.435-23.974 19.851-43.309 43.857-43.614v-1.664c-23.892-.434-43.176-19.718-43.61-43.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.278,
    cy: 54.167,
    r: 2.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.722,
    cy: 54.167,
    r: 2.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3.556,
    d: "m53.53 66.905 11.162-6.445M55.308 60.46l11.162 6.445"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "poll-poll-e-oops_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgPollPollEOops;